import { render, staticRenderFns } from "./BannerSmall.vue?vue&type=template&id=3a3fec9b&scoped=true&"
import script from "./BannerSmall.vue?vue&type=script&lang=js&"
export * from "./BannerSmall.vue?vue&type=script&lang=js&"
import style0 from "./BannerSmall.vue?vue&type=style&index=0&id=3a3fec9b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3fec9b",
  null
  
)

export default component.exports